/**
 * Helper para componer clases de Tailwind con deduplicación inteligente.
 *
 * - `clsx` permite arrays/objetos/condicionales: `cn('p-2', { 'bg-red': isError })`.
 * - `tailwind-merge` resuelve conflictos: `cn('px-2', 'px-4')` → `'px-4'`.
 *
 * Convención §2.7 de GUIA_REACT_v2.
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
